import { Spinner } from '@sbab-ui/components'
import { useEffect, useReducer, useState } from 'react'
import { fetchInterestRate } from '../api/httpHandlers'
import { calculatorReducer } from '../state/appState'
import Calculator from '../components/Calculator'
import ErrorMessage from '../components/ErrorMessage'
import Result from '../components/Result'
import TopSection from '../components/TopSection'
import { track } from '../lib/tracking'

export const appConfiguration = {
  startAmount: {
    default: 10000,
    minValue: 0,
    maxValue: 9999999,
  },
  savedEachMonth: {
    default: 1000,
    minValue: 0,
    maxValue: 999999,
  },
  savingTimeInYears: {
    default: 5,
    minValue: 1,
    maxValue: 99,
  },
}

export default function PrivateApp() {
  const [isLoading, setIsLoading] = useState(true)
  const [hasFetchError, setHasFetchError] = useState(false)
  const [state, dispatch] = useReducer(calculatorReducer, {
    interestRate: 0,
    startAmount: appConfiguration.startAmount.default,
    savedEachMonth: appConfiguration.savedEachMonth.default,
    savingTimeInYears: appConfiguration.savingTimeInYears.default,
    totalAmount: 0,
    accumulatedInterest: 0,
    accumulatedDeposited: 0,
    hasCalculationError: false,
  })

  function inputChangeHandler(event: React.ChangeEvent<HTMLInputElement>) {
    const field = event.currentTarget.getAttribute('data-label') ?? ''
    if (field !== 'startAmount' && field !== 'savedEachMonth' && field !== 'savingTimeInYears')
      return dispatch({ type: 'error' })
    track('change', event.currentTarget.getAttribute('data-label') ?? '')
    const formattedString = event.currentTarget.value.replaceAll(' ', '')
    const value = +formattedString
    dispatch({ type: 'fieldChange', field, value })
  }

  useEffect(() => {
    async function getInterestRate() {
      const result = await fetchInterestRate()
      if (result.successful) {
        dispatch({ type: 'interestRateChange', value: result.data })
        setIsLoading(false)
      } else {
        setIsLoading(false)
        setHasFetchError(true)
      }
    }
    getInterestRate()
  }, [])

  return (
    <section>
      {isLoading ? (
        <div className="flex h-96 items-center justify-center">
          <Spinner size="large" />
        </div>
      ) : null}
      {hasFetchError ? <ErrorMessage /> : null}
      {!isLoading && !hasFetchError ? (
        <>
          <TopSection />
          <Result appState={state} />
          <Calculator inputChangeHandler={inputChangeHandler} appState={state} />
        </>
      ) : null}
    </section>
  )
}
